export const v1Currencies = [
  { isoCode: 'AUD' },
  { isoCode: 'CAD' },
  { isoCode: 'CHF' },
  { isoCode: 'CNY' },
  { isoCode: 'CZK' },
  { isoCode: 'DKK' },
  { isoCode: 'EUR' },
  { isoCode: 'GBP' },
  { isoCode: 'HKD' },
  { isoCode: 'HRK' },
  { isoCode: 'HUF' },
  { isoCode: 'ILS' },
  { isoCode: 'JPY' },
  { isoCode: 'NOK' },
  { isoCode: 'NZD' },
  { isoCode: 'PLN' },
  { isoCode: 'RON' },
  { isoCode: 'SEK' },
  { isoCode: 'USD' },
];

export const otherCurrencies = [
  { isoCode: 'AED' },
  { isoCode: 'BHD' },
  { isoCode: 'SAR' },
  { isoCode: 'SGD' },
  { isoCode: 'THB' },
  { isoCode: 'TND' },
  { isoCode: 'TRY' },
  { isoCode: 'ZAR' },
];
export default [...v1Currencies, ...otherCurrencies.map(currency => ({ ...currency, v1: false }))];
